export default __webpack_public_path__ + "static/media/blog1.9fb77764.png";